<template>
  <svg
    :style="iconSizeStyle"
    :viewBox="viewBox"
    @click="event => $emit('click', event)"
    class="smart-icon"
    fill="currentColor"
    style="vertial-align: middle"
  />
</template>

<script>
// @flow
import { createSvgLegacy, setSvgFill, isUndef } from 'utils';

export default {
  name: 'SmartIcon',
  props: {
    size: {
      type: Number,
      default: 1,
      validator(value: number): boolean {
        return value > 0;
      }
    },
    path: {
      type: String
    },
    type: {
      type: String,
      default: 'small',
      validator(value: string): boolean {
        return ['small', 'big'].includes(value);
      }
    },
    name: {
      type: String,
      default: 'home'
    }
  },
  data: () => ({
    viewBox: '0 0 24 24'
  }),
  computed: {
    iconSize() {
      const DEFAULT_SIZE = 8;
      const MIN_SIZE = this.size + 1;

      return `${MIN_SIZE * DEFAULT_SIZE}px`;
    },
    iconSizeStyle() {
      return {
        width: this.iconSize,
        height: this.iconSize
      };
    }
  },
  mounted() {
    this.createSvgElement();
  },
  watch: {
    name() {
      this.createSvgElement();
    }
  },
  methods: {
    createSvgElement() {
      const output = document.createElement('div');

      // eslint-disable-next-line
       let source = require(`assets/icons/${this.type}/${this.name}.svg`);

      output.innerHTML = source;
      const svg = output.querySelector('svg');
      if (!svg) { return; }

      if (isUndef(svg.innerHTML)) {
        createSvgLegacy(this.$el, source);
      } else {
        this.$el.innerHTML = svg.innerHTML;
      }

      setSvgFill(this.$el);
      this.viewBox = svg.getAttribute('viewBox');
    }
  }
};
</script>
